// confetti-cart.js

document.addEventListener('DOMContentLoaded', function () {
  const addToCartButtons = document.querySelectorAll(
    'form[action*="/cart/add"] button[type="submit"]'
  );

  addToCartButtons.forEach(button => {
    button.addEventListener('click', function () {
      if (typeof confetti === 'function') {
        // Burst 3 times for effect
        const burstCount = 3;
        for (let i = 0; i < burstCount; i++) {
          setTimeout(() => {
            confetti({
              particleCount: 60,
              spread: 70 + Math.random() * 30, // randomize spread
              startVelocity: 30 + Math.random() * 20,
              angle: 60 + Math.random() * 60, // random angle
              origin: { 
                x: 0.3 + Math.random() * 0.4, // center-ish
                y: 0.6 
              },
              colors: [
                '#FF6B6B', '#FFD93D', '#6BCB77', '#4D96FF', '#FF8E00', '#D63384'
              ] // bright fun palette
            });
          }, i * 200); // stagger bursts
        }
      }
    });
  });
});
